import * as prismic from "@prismicio/client";

export const repositoryName = "Endya";

export const prismicClient = prismic.createClient(repositoryName, {
  accessToken: import.meta.env.VITE_PRISMIC_ACCESS_KEY,
});
